import {Col, Row, Tabs, TabsProps} from "antd";
import {FormattedMessage} from "react-intl";
import '../assets/css/Dentobook.css';

import DetailWrapper from "../components/common/DetailWrapper";
import Clinics from '../components/organization/Clinics';
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";
import Status from "../components/organization/Status";
import General from "../components/organization/General";
import MedicalHistory from "../components/organization/MedicalHistory";
import Treatments from "../components/organization/Treatments";
import Documents from "../components/organization/Documents";
import {useContext, useState} from "react";
import GoogleCalendarSettings from "../components/organization/GoogleCalendarSettings";
import MessagingSettings from "../components/organization/MessagingSettings";
import {isMobileOnly} from "react-device-detect";
import {DentobookApplicationContext} from "../context/DentobookApplicationContext";

const Organization = () => {

    const {principal, userOrganization} = useContext(DentobookApplicationContext);
    const [isEditMode, setIsEditMode] = useState(false);

    // Don't render tabs until userOrganization is loaded to prevent tab position jumping
    if (!userOrganization) {
        return null;
    }

    const items: TabsProps['items'] = [
        {
            label: <FormattedMessage id="general"/>,
            key: 'general',
            disabled: isEditMode,
            children: <General isEditMode={isEditMode} setIsEditMode={setIsEditMode}/>
        },
    ];

    // Add Clinics tab at position 1 (always visible)
    // if (principal?.features.includes('TREATMENT_ROOMS_REGISTRY')) {
        items.splice(1, 0,
            {
                label: <FormattedMessage id="clinics"/>,
                key: 'app',
                disabled: isEditMode,
                children: <Clinics/>
            });
    // }

    // Add Conditions, Operations, Medical History tabs at position 2-4
    if (principal?.features.includes('CONDITIONS_OPERATIONS_MEDICAL_HISTORY_CREATION')) {
        items.splice(2, 0,
            {
                label: <FormattedMessage id="conditions"/>,
                key: 'conditions',
                disabled: isEditMode,
                children: <Status/>
            },
            {
                label: <FormattedMessage id="operations"/>,
                key: 'operations',
                disabled: isEditMode,
                children: <Treatments/>
            },
            {
                label: <FormattedMessage id="medicalHistoryLabel"/>,
                key: 'medical-history',
                disabled: isEditMode,
                children: <MedicalHistory/>
            },);
    }

    // Add Documents tab at position 5 (after Medical History, before Google Credentials)
    // This ensures stable position regardless of async context loading
    // Available to all organizations (removed country gate)
    items.splice(5, 0, {
        label: <FormattedMessage id="documents"/>,
        key: 'documents',
        disabled: isEditMode,
        children: <Documents/>
    });

    // Add Google Calendar tab at the end (removed feature gating - available to all)
    items.push({
        label: <FormattedMessage id="googleCalendar"/>,
        key: 'google-calendar',
        disabled: isEditMode,
        children: <GoogleCalendarSettings/>
    });

    // Add Messaging Settings tab at the end
    items.push({
        label: <FormattedMessage id="messaging_settings"/>,
        key: 'messaging',
        disabled: isEditMode,
        children: <MessagingSettings setIsEditMode={setIsEditMode}/>
    });

    return (
        <AccessControl
            accessibleFor={[accessibilityRoles.CLINIC_ADMIN]}>
            <DetailWrapper>
                <Row className="mb-2">
                    <Col span={12}>
                        <h3><FormattedMessage id="organization_settings"/></h3>
                    </Col>
                </Row>
                <Tabs key="main-information" items={items}/>
                {isMobileOnly ? <div style={{marginBottom: 150}}></div> : null}
            </DetailWrapper>
        </AccessControl>
    );
};


export default Organization;
